import React, { useState, useRef, useEffect } from "react";
import Messages from "../../../constant/Messages";
import axios from "axios";
import { setData } from "../../../utils/CookieUtiles";
import checkNetworkStatus from "../../common/networkStatus/CheckNetworkStatus";
import useShowAlert from "../../../utils/AlertUtiles";
import { CircularProgress } from "@mui/material";
import uRLs from "../../../utils/baseUtils";
import { removeAllWhitespace } from "../../../utils/helper";
import VisibilityOffOutlinedIcon from '@mui/icons-material/VisibilityOffOutlined';
import VisibilityOutlinedIcon from '@mui/icons-material/VisibilityOutlined';
import handleError from "../../../constant/handleError";
function Login({ setLoggedIn }) {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState({});
  const [showPassword, setShowPassword] = useState(false);

  const passwordRef = useRef(null);
  const emailRef = useRef(null);
  const showAlert = useShowAlert();

  const validateFields = () => {
    const errors = {};
    if (!email) {
      errors.email = Messages.AUTH.USERNAME_EMPTY;
      emailRef.current.focus();
    } else if (!password) {
      errors.password = Messages.AUTH.PASSWORD_EMPTY;
      passwordRef.current.focus();
    }
    else if (password.length < 3) {
    errors.password = "Password must be at least 3 characters.";
    passwordRef.current.focus();
  }
    setErrors(errors);
    return errors;
  };

  const handleLogin = async (e) => {
    e.preventDefault();
    const errors = validateFields();

    if (Object.keys(errors).length > 0) {
      {
        return;
      }
    }
    setLoading(true);
    checkNetworkStatus();
      const data={
          username:email,
          password:password
      }
    try {
      const response = await axios.post(
        `${uRLs.BASE_URL}ownerauth/`,data      
      );
      if (response?.data?.results?.accessToken) {
        setData("AccessToken", response.data.results.accessToken);
        setData("RefreshToken", response.data.results.refreshToken);
        showAlert("success", Messages.SUCCESS.LOGIN_SUCCESS);

        setLoggedIn(true);
      }
    } catch (error) { 
      if(error.response?.data?.code ==="UNAUTHORIZED"){
         errors.password = "Invalid username or password";
      }else{
       handleError(error, showAlert);
      }      
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (emailRef.current) {
      emailRef.current.focus();
    }
  }, []);
  const handleTogglePassword = () => {
    setShowPassword((prev) => !prev);
  };
  return (
    <div>
      <div className="wrapper">
        <div className="section-authentication-signin d-flex align-items-center justify-content-center my-5 my-lg-0">
          <div class="container-fluid my-5 my-lg-0">
            <div class="row">
              <div class="col-12 col-md-8 col-lg-6 col-xl-5 col-xxl-4 mx-auto">
                <div className="card mb-0  rounded-4 ">
                  <div className="card-body">
                    <div className="p-4 pt-0">
                      <div className="mb-0 text-center">
                        <img
                          src={uRLs.LOGO_IMAGE1}
                          width="130"
                          alt=""
                          className="mb-2"
                        />
                      </div>
                      <div className="text-center mb-4">
                        <h4 class="fw-bold">Admin Portal</h4>
                        <p class="mb-0">
                          Fill your credentials to login your account
                        </p>
                      </div>
                      <div className="form-body">
                        <form
                          className="row g-3"
                          id="ownerLoginForm"
                          onSubmit={handleLogin}
                        >
                          
                          <div className="col-12">
                            <label htmlFor="new-username" className="form-label">
                              Username <span className="text-danger">*</span>
                            </label>
                            <input
                              type="text"
                              className="form-control LogInTindex"
                              id="new-username"
                              value={email}
                              onChange={(e) => {
                                setEmail(removeAllWhitespace(e.target.value));
                                setErrors("");
                              }}
                              autoComplete="off"
                              ref={emailRef}
                            />{" "}
                            {errors.email && (
                              <div className="error-message invalid-feedback">
                                {errors.email}
                              </div>
                            )}
                          </div>

                          <div className="col-12">
                            <label htmlFor="amsha-pass" className="form-label">
                              Password <span className="text-danger">*</span>
                            </label>
                            <div class="input-group" id="show_hide_password">
                              <input
                                type={showPassword ? "text" : "password"}
                                className="form-control LogInTindex"
                                id="amsha-pass"
                              autoComplete="new-password"
                                value={password}
                                ref={passwordRef}
                                onChange={(e) => {
                                  setPassword(
                                    removeAllWhitespace(e.target.value)
                                  );
                                  setErrors("");
                                }}
                              />{" "}
                              <div
                                className="input-group-text bg-transparent cursor-pointer"
                                onClick={handleTogglePassword}
                              >
                                <span className="">
                                  {showPassword ? (
                                    <VisibilityOutlinedIcon />
                                  ) : (
                                    <VisibilityOffOutlinedIcon/>
                                  )}
                                </span>
                              </div>
                            </div>
                            {errors.password && (
                              <div className="error-message invalid-feedback">
                                {errors.password}
                              </div>
                            )}
                          </div>
                           <div class="col-12 ">
                             <div class="d-grid">
                                {loading ? (
                                  <button
                                    className="btn btn-primary pb-0 text-center"
                                    disabled
                                  >
                                    <CircularProgress
                                      size={22}
                                      className="text-white"
                                    />
                                  </button>
                                ) : (
                                  <button
                                    // ref={buttonRef}
                                    type="submit"
                                    className="btn btn-primary text-center"
                                    onClick={handleLogin}
                                  >
                                    Log In
                                  </button>
                                )}
                             </div>
                          </div>
                        </form>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Login;